import produce from 'immer';

import { CommanderMonitoringFilterLogicalObject } from './filter.model';

export function checkDefaultChannels(
  commanderMonitoringFilterLogicalObject: CommanderMonitoringFilterLogicalObject,
  channels: string[]
) {
  const defaultChannels = channels;
  return produce(
    commanderMonitoringFilterLogicalObject,
    (commanderMonitoringFilterLogicalObjectDraft) => {
      for (const deviceId in commanderMonitoringFilterLogicalObjectDraft) {
        if (
          Object.hasOwn(commanderMonitoringFilterLogicalObjectDraft, deviceId)
        ) {
          const deviceObjectFilter =
            commanderMonitoringFilterLogicalObjectDraft[deviceId];

          for (const controlUnitId in deviceObjectFilter) {
            if (Object.hasOwn(deviceObjectFilter, controlUnitId)) {
              const controlUnitObjectFilter = deviceObjectFilter[controlUnitId];
              for (const eventId in controlUnitObjectFilter) {
                if (Object.hasOwn(controlUnitObjectFilter, eventId)) {
                  if (defaultChannels.includes(eventId)) {
                    controlUnitObjectFilter[eventId] = true;
                  }
                }
              }
            }
          }
        }
      }
    }
  );
}
